export default __webpack_public_path__ + "static/media/1055.8a7df4c9.svg";